import { FilterControls } from "./FilterControls";
import { Button } from "@/components/ui/button";
import { SlidersHorizontal } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { Product } from "@/types/product";

interface FiltersSectionProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  priceRange: [number, number];
  setPriceRange: (range: [number, number]) => void;
  products: Product[];
  selectedBrand: string;
  setSelectedBrand: (brand: string) => void;
  allBrands: string[];
  selectedRating: string;
  setSelectedRating: (rating: string) => void;
  selectedAvailability: string[];
  setSelectedAvailability: (availability: string[]) => void;
  selectedDomain: string;
  setSelectedDomain: (domain: string) => void;
  availableDomains: string[];
}

export const FiltersSection = ({
  isOpen,
  setIsOpen,
  priceRange,
  setPriceRange,
  products,
  selectedBrand,
  setSelectedBrand,
  allBrands,
  selectedRating,
  setSelectedRating,
  selectedAvailability,
  setSelectedAvailability,
  selectedDomain,
  setSelectedDomain,
  availableDomains,
}: FiltersSectionProps) => {
  return (
    <>
      <div className="md:hidden w-full">
        <Collapsible open={isOpen} onOpenChange={setIsOpen}>
          <CollapsibleTrigger asChild>
            <Button variant="outline" className="w-full mb-4">
              <SlidersHorizontal className="mr-2 h-4 w-4" />
              Filters {isOpen ? '(Hide)' : '(Show)'}
            </Button>
          </CollapsibleTrigger>
          <CollapsibleContent className="space-y-4">
            <FilterControls
              priceRange={priceRange}
              setPriceRange={setPriceRange}
              minPrice={Math.min(...(products.length ? products.map(p => p.price) : [1]))}
              maxPrice={Math.max(...(products.length ? products.map(p => p.price) : [5000]))}
              hasRatings={false}
              setHasRatings={() => {}}
              inStock={false}
              setInStock={() => {}}
              selectedBrand={selectedBrand}
              setSelectedBrand={setSelectedBrand}
              availableBrands={allBrands}
              selectedRating={selectedRating}
              setSelectedRating={setSelectedRating}
              selectedAvailability={selectedAvailability}
              setSelectedAvailability={setSelectedAvailability}
              availableAvailabilities={Array.from(
                new Set(
                  products
                    .map((product) => product.p_availability)
                    .filter((availability): availability is string => !!availability)
                )
              ).sort()}
              selectedDomain={selectedDomain}
              setSelectedDomain={setSelectedDomain}
              availableDomains={availableDomains}
            />
          </CollapsibleContent>
        </Collapsible>
      </div>

      <div className="hidden md:block">
        <FilterControls
          priceRange={priceRange}
          setPriceRange={setPriceRange}
          minPrice={Math.min(...(products.length ? products.map(p => p.price) : [1]))}
          maxPrice={Math.max(...(products.length ? products.map(p => p.price) : [5000]))}
          hasRatings={false}
          setHasRatings={() => {}}
          inStock={false}
          setInStock={() => {}}
          selectedBrand={selectedBrand}
          setSelectedBrand={setSelectedBrand}
          availableBrands={allBrands}
          selectedRating={selectedRating}
          setSelectedRating={setSelectedRating}
          selectedAvailability={selectedAvailability}
          setSelectedAvailability={setSelectedAvailability}
          availableAvailabilities={Array.from(
            new Set(
              products
                .map((product) => product.p_availability)
                .filter((availability): availability is string => !!availability)
            )
          ).sort()}
          selectedDomain={selectedDomain}
          setSelectedDomain={setSelectedDomain}
          availableDomains={availableDomains}
        />
      </div>
    </>
  );
};